import { AdminService } from './source/adminSource';
import { CreditorsService } from './source/creditorsSource';
import { LoginService } from './source/loginSource';
import { PADContactService } from './source/padContactSource';
import { ReportService } from './source/reportSource';
import { SepaCountries } from './source/sepaCountries.factory';
import { TicketsProvider, TicketsService } from './source/ticketsSource';

/**
 * Collect all data sources and export their services.
 */
export {
  AdminService,
  CreditorsService,
  LoginService,
  PADContactService,
  ReportService,
  SepaCountries,
  TicketsProvider,
  TicketsService,
};
